import { render } from "./single-card.vue?vue&type=template&id=0b8edc57"
import script from "./single-card.vue?vue&type=script&lang=js"
export * from "./single-card.vue?vue&type=script&lang=js"

import "./single-card.vue?vue&type=style&index=0&id=0b8edc57&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__